import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Pageable } from '../../models/common/pageable.model';
import {ArticleListInfo, PigletArticleListInfo} from '../../models/article/article-list-info.model';
import { ArticleDetail } from '../../models/article/article-detail.model';
import {ArticleCategoryModel} from '../../models/article/article-category.model';
import {ArticleCategoryTypeModel} from '../../models/article/article-category-type.model';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {
  private readonly baseUrl = `${environment.backend.url}/api/article/v1`;

  constructor(private readonly http: HttpClient) { }

  public getArticles(type: number = 1, page: number = 0, ipp: number = 5, locale: string = 'pt-br'): Observable<Pageable<ArticleListInfo>> {
    let params = new HttpParams()
      .set('type', type.toString())
      .set('page', page.toString())
      .set('ipp', ipp.toString())
      .set('locale', locale);

    return this.http.get<Pageable<ArticleListInfo>>(this.baseUrl, { params });
  }

  public getArticlesByCategory(type: number = 1, page: number = 0, ipp: number = 5, locale: string = 'pt-br') {
    let params = new HttpParams()
      .set('type', type.toString())
      .set('page', page.toString())
      .set('ipp', ipp.toString())
      .set('locale', locale);

    return this.http.get<Pageable<ArticleListInfo>>(`${this.baseUrl}/by-category`, { params });
  }

  public getArticleById(articleId: number): Observable<ArticleDetail> {
    return this.http.get<ArticleDetail>(`${this.baseUrl}/id/${articleId}`);
  }

  public getArticleCategoriesByType(articleCategoryTypeId: number) {
    return this.http.get<ArticleCategoryModel[]>(`${this.baseUrl}/category-type/${articleCategoryTypeId}`);
  }

  public getArticleCategoryTypes() {
    return this.http.get<ArticleCategoryTypeModel[]>(`${this.baseUrl}/category-types`);
  }
}
